import { Keuzehulp } from '../keuzehulpen'

const erectieproblemen: Keuzehulp = {
  title: 'Erectieproblemen',
  basePath: '/erectieproblemen',
  documentTitle: 'Erectieproblemen',
  routes: [
    {
      path: '',
      routeId: 'P12-001',
      nextRouteId: 'P12-002',
      type: 'intro',
      title: 'Voordat je begint…',
      backButton:
        'https://www.thuisarts.nl/keuzehulp/uw-penis-wordt-niet-goed-stijf-wat-kunt-u-doen',
      columns: [
        {
          title: 'Neem de tijd',
          description: 'Neem alle tijd die u nodig heeft om de keuzehulp in te vullen',
        },
        {
          title: '20 tot 30 minuten',
          description: 'Zo lang zijn de meeste mensen bezig met deze keuzehulp',
        },
        {
          title: 'Zoek een rustige plek',
          description: 'Zodat u goed uw aandacht erbij kunt houden',
        },
        {
          title: 'Download uw antwoorden',
          description:
            'Uw antwoorden worden niet bewaard. De keuzehulp onthoudt niet waar u gebleven bent',
        },
      ],
    },
    {
      path: '/stap-1',
      routeIndex: '1',
      routeId: 'P12-002',
      nextRouteId: 'P12-003',
      type: 'chapter',
      title: 'Wat is er nodig voor een stijve penis?',
      subtitle: 'Stap 1',
      description: `
        <p>We leggen eerst uit hoe een penis stijf wordt. Daarna kunt u lezen waardoor het kan komen dat uw penis niet goed stijf wordt. In het laatste deel vertellen we wat u zelf kunt doen en welke behandelingen er zijn.</p>
      `,
      image: {
        src: `${process.env.PUBLIC_URL}/img/ep-stap-1.jpg`,
        alt: '',
      },
      button: 'Ga verder',
    },
    {
      path: '/stap-1/hoe-wordt-een-penis-stijf',
      routeId: 'P12-003',
      nextRouteId: 'P12-004',
      type: 'popupCards',
      title: 'Hoe wordt een penis stijf?',
      align: 'left',
      description: `
        <div>
          <p>Voor een stijve penis zijn veel dingen nodig. Klik op de onderwerpen waar u meer over wilt weten.</br>
          Goed om te weten: voor klaarkomen hoeft u geen stijve penis te hebben. U kunt ook klaarkomen zonder een stijve penis.</p>
        </div>
      `,
      cards: [
        {
          cardTitle: 'Seksuele prikkels',
          readingTime: '1 minuut leestijd',
          image: {
            src: `${process.env.PUBLIC_URL}/img/ep-stap-1_1-card.jpg`,
            alt: '',
          },
          modalContent: `
            <div>
              <p>Prikkels zijn dingen die u ziet, hoort, ruikt, voelt of denkt. Dat moeten prikkels zijn die voor u seksueel zijn en die u op dat moment fijn vindt. Voor veel mensen zijn dit bijvoorbeeld seksuele prikkels:</p>
              <ul>
                <li>kijken naar een bloot lichaam</li>
                <li>kijken naar een penis, vagina of borsten</li>
                <li>een penis, vagina, borsten of billen aanraken met de hand of mond</li>
                <li>goede herinneringen aan seks</li>
                <li>iemand die u aanraakt</li>
                <li>eigen seks-fantasie, bijvoorbeeld over hoe iemand kijkt, iemand die u aanraakt of een geur</li>
                <li>kijken naar mensen die seks hebben, zoals bij porno</li>
              </ul>

              <img src=${process.env.PUBLIC_URL}/img/ep-stap-1_1.jpg alt="" />
            </div>
          `,
        },
        {
          cardTitle: 'Hormonen',
          readingTime: '1 minuut leestijd',
          image: {
            src: `${process.env.PUBLIC_URL}/img/ep-stap-1_2-card.jpg`,
            alt: '',
          },
          modalContent: `
            <div>
              <p>Uw hormonen zorgen ervoor dat u gevoelig bent voor seksuele prikkels en zin in seks krijgt. Testosteron is een voorbeeld van een hormoon.</p>
              <img src=${process.env.PUBLIC_URL}/img/ep-stap-1_2.jpg alt="" />
            </div>
          `,
        },
        {
          cardTitle: 'De situatie en hoe u zich voelt',
          readingTime: '1 minuut leestijd',
          image: {
            src: `${process.env.PUBLIC_URL}/img/ep-stap-1_3-card.jpg`,
            alt: '',
          },
          modalContent: `
            <div>
              <p>Voor een stijve penis moet de situatie zo zijn dat u gevoelig bent voor seksuele prikkels. Het helpt als u niet gestoord kunt worden. Zoals door uw telefoon of uw kinderen. Daardoor bent u meer ontspannen.</p>

              <p>Het is ook belangrijk dat u zich goed voelt over uw lichaam en over uw relatie.</p>
              <img src=${process.env.PUBLIC_URL}/img/ep-stap-1_3.jpg alt="" />
            </div>
          `,
        },
        {
          cardTitle: 'Gezonde zenuwen, bloedvaten en zwel-lichamen',
          readingTime: '2 minuten leestijd',
          image: {
            src: `${process.env.PUBLIC_URL}/img/ep-stap-1_4-card.jpg`,
            alt: '',
          },
          modalContent: `
            <div>
              <p>Uw lichaam moet iets kunnen doen met de prikkels . Via uw zenuwen gaan er seintjes naar uw hersenen. Uw hersenen sturen dan weer seintjes naar de bloedvaten en zenuwen van uw penis.
              Dat zorgt ervoor dat er veel bloed in de zwel-lichamen van de penis stroomt. Zwel-lichamen zijn een soort spons van spieren met veel bloedvaten erin. Als daar veel bloed instroomt, wordt de penis stijf.</p>

              <p>'s Nachts gebeurt dit ook een paar keer in uw droomslaap. Terwijl u slaapt, zijn uw hersenen actief. Die zorgen ervoor dat er meer bloed in uw penis komt. Als u wakker wordt in zo'n droomslaap, merkt u dat uw penis stijf is.
              Dit gebeurt vaak bij mannen als ze ’s ochtends wakker worden.</p>

              <p>Heeft u ’s ochtends geen stijve penis? Dat betekent niet dat er een probleem is. Het kan zijn dat uw droomslaap al eerder afgelopen was.</p>
              <img src=${process.env.PUBLIC_URL}/img/ep-stap-1_4.jpg alt="" />
            </div>
          `,
        },
      ],
      button: 'Klaar met lezen, naar de volgende stap',
    },
    {
      path: '/stap-2',
      routeIndex: '2',
      routeId: 'P12-004',
      nextRouteId: 'P12-005',
      type: 'chapter',
      title: 'Waardoor kan uw penis niet goed stijf worden?',
      subtitle: 'Stap 2',
      description: `
          <p>U weet nu wat meer over wat er nodig is voor een stijve penis. We vertellen nu wat meer over waardoor het kan komen dat uw penis niet goed stijf wordt of blijft.</p>
        `,
      image: {
        src: `${process.env.PUBLIC_URL}/img/ep-stap-2.jpg`,
        alt: '',
      },
      button: 'Ga verder',
    },
    {
      path: '/stap-2/vaak-meer-oorzaken-tegelijk',
      routeId: 'P12-005',
      nextRouteId: 'P12-006',
      type: 'explanation',
      title: 'Vaak meer oorzaken tegelijk',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>Als uw penis niet goed stijf wordt, kan dit met veel dingen te maken hebben. Er zijn oorzaken die te maken hebben met:</p>

          <ul>
            <li>uw lichaam</li>
            <li>uw gedachten</li>
            <li>de situatie en uw relatie</li>
          </ul>

          <p>Vaak zijn er meer oorzaken tegelijk.</p>

          <p>Op de volgende pagina's kunt u kiezen over welke oorzaken u meer wilt weten.</p>
        </div>
      `,
      button: 'Ga verder',
    },
    {
      path: '/stap-2/oorzaken-in-uw-lichaam',
      routeId: 'P12-006',
      nextRouteId: 'P12-007',
      type: 'popupCards',
      title: 'Oorzaken in uw lichaam',
      align: 'left',
      description: `
        <div>
          <p>Hieronder staan dingen in uw lichaam die kunnen zorgen dat uw penis niet goed stijf wordt. </br> Klik op de onderwerpen waar u meer over wilt weten.</p>
        </div>
      `,
      cards: [
        {
          cardTitle: 'Veranderingen als u ouder wordt',
          readingTime: '2 minuten leestijd',
          image: {
            src: `${process.env.PUBLIC_URL}/img/ep-stap-1_4-card.jpg`,
            alt: '',
          },
          modalContent: `
            <div>
              <p>Als u ouder wordt, wordt uw penis vaak minder stijf. Vaak blijft de penis ook minder lang stijf.</p>

              <p style="margin-bottom:0;">Dat kan komen door deze veranderingen:</p>
              <ul style="margin-top: 0;">
                <li>Uw zenuwen, bloedvaten en zwel-lichamen worden ouder. De bloedvaten worden bijvoorbeeld nauwer waardoor er minder bloed door kan.</li>
                <li>Uw penis kan minder gevoelig worden voor prikkels. Er is meer tijd nodig om een stijve penis te krijgen. Ook zijn er meer en sterkere seksuele prikkels nodig. Dit is heel normaal. Het hoort bij ouder worden.</li>
                <li>Sommige mannen hebben minder mannelijk hormoon (testosteron) als ze ouder worden.</li>
                <li>Ook klaarkomen verandert vaak: het wordt een minder sterk gevoel.</li>
              </ul>

              <p>Soms lukt klaarkomen niet meer. Of u komt juist sneller klaar dan vroeger. Snel weer een stijve penis krijgen na klaarkomen lukt ook niet meer goed. Hoe ouder het lichaam wordt,
              hoe meer tijd er nodig is om opnieuw een stijve penis te krijgen. Deze dingen kunnen ervoor zorgen dat u minder zin krijgt in seks als u ouder wordt.</p>

              <img src=${process.env.PUBLIC_URL}/img/ep-stap-1_4.jpg alt="" />

            </div>
          `,
        },
        {
          cardTitle: 'Ongezond leven, vooral te zwaar zijn en roken',
          readingTime: '3 minuten leestijd',
          image: {
            src: `${process.env.PUBLIC_URL}/img/ep-stap-2_2_2-card.jpg`,
            alt: '',
          },
          modalContent: `
            <div>
              <p>Ongezond leven is roken, ongezond eten, weinig bewegen, veel alcohol drinken of drugs gebruiken. Door ongezond leven kan het moeilijker worden om een stijve penis te krijgen. Of een stijve penis te houden tijdens seks.</p>

              <h2 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Als u rookt:</h2>
              <p style="margin-top: 0;">Uw bloedvaten worden minder soepel en gaan langzaam dicht zitten. Zo kan bloed minder goed naar de zwel-lichamen in uw penis stromen.</p>

              <h2 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Als u te zwaar bent:</h2>
              <p style="margin-top: 0;">U kunt minder testosteron krijgen door te veel buikvet. Daardoor kunt u minder zin in seks hebben.</p>

              <h2 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Als u veel alcohol drinkt:</h2>
              <p style="margin-top: 0;">Als u alcohol gedronken heeft, kunt u moeilijker een stijve penis krijgen en klaarkomen. Als u jarenlang te veel alcohol drinkt, kunnen uw zenuwen slechter werken. Ook de zenuwen tussen uw penis en uw hersenen.</p>

              <h2 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Als u drugs gebruikt:</h2>
              <p style="margin-top: 0;">Als u drugs gebruikt heeft, is het vaak lastiger om een stijve penis te krijgen.<br/> En als u jarenlang drugs gebruikt, gaan uw zenuwen slechter werken. Ook worden de geluks-stoffen in de hersenen minder.</p>

              <h2 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Als u anabolen gebruikt:</h2>
              <p style="margin-top: 0;">Anabolen lijken op het hormoon testosteron. Testosteron is nodig om een stijve penis te krijgen. Als u anabolen gebruikt, is uw lichaam niet gewend om zelf testosteron te maken. Daardoor lukt het tijdens de seks vaak niet om een stijve penis te krijgen.</p>
              <img src=${process.env.PUBLIC_URL}/img/ep-stap-2_2_2.jpg alt="" />
            </div>
          `,
        },
        {
          cardTitle: 'Lichamelijke problemen, zoals pijn of een ziekte',
          readingTime: '1 minuten leestijd',
          image: {
            src: `${process.env.PUBLIC_URL}/img/ep-stap-2_2_3-card.jpg`,
            alt: '',
          },
          modalContent: `
            <div>
              <p>Een ziekte kan ervoor zorgen dat uw lichaam niet meer helemaal goed werkt. De zenuwen die nodig zijn voor een stijve penis werken bijvoorbeeld niet goed. Of uw hormonen en bloedvaten werken minder goed.</p>

              <p style="margin-bottom: 0;">Misschien heeft u een ziekte die pijn geeft, moeheid of problemen met bewegen.<br/>Zo kunnen bijvoorbeeld deze ziektes zorgen voor een minder stijve penis:</p>
              <ul style="margin-top: 0;">
                <li>diabetes met vaak hoge bloedsuikers</li>
                <li>een ziekte waarbij de zenuwen niet goed werken</li>
                <li>een ziekte van uw hart of bloedvaten</li>
                <li>kanker</li>
              </ul>
              <img src=${process.env.PUBLIC_URL}/img/ep-stap-2_2_3.jpg alt="" />
            </div>
          `,
        },
        {
          cardTitle: 'Bijwerking van een behandeling',
          readingTime: '2 minuten leestijd',
          image: {
            src: `${process.env.PUBLIC_URL}/img/ep-stap-2_2_4-card.jpg`,
            alt: '',
          },
          modalContent: `
            <div>
              <p style="margin-bottom: 0;">Medicijnen en andere behandelingen kunnen als bijwerking zorgen voor een minder stijve penis. Bijvoorbeeld:</p>
              <ul style="margin-top: 0;">
                <li>medicijnen die de bloeddruk lager maken (zoals sommige plaspillen)</li>
                <li>medicijnen tegen depressie en angst</li>
                <li>medicijnen tegen erg in de war zijn (psychose)</li>
                <li>middelen om rustig te worden (kalmerings-pillen)</li>
                <li>bepaalde medicijnen tegen plasklachten</li>
                <li>de behandeling van prostaatkanker. Zoals een operatie, bestraling of chemotherapie. Dat komt omdat er dan
                zenuwen en bloedvaten naar de penis kapot kunnen gaan.</li>
              </ul>
              <img src=${process.env.PUBLIC_URL}/img/ep-stap-2_2_4.jpg alt="" />
            </div>
          `,
        },
      ],
      button: 'Klaar met lezen, naar de volgende stap',
    },
    {
      path: '/stap-2/gedachten-als-oorzaak',
      routeId: 'P12-007',
      nextRouteId: 'P12-008',
      type: 'popupCards',
      title: 'Gedachten als oorzaak',
      align: 'left',
      description: `
        <div>
          <p>Hieronder staat hoe gedachten kunnen zorgen dat uw penis niet goed stijf wordt.
          Klik op de onderwerpen waar u meer over wilt weten.</p>
        </div>
      `,
      cards: [
        {
          cardTitle: 'Onzeker voelen',
          readingTime: '1 minuut leestijd',
          image: {
            src: `${process.env.PUBLIC_URL}/img/ep-stap-2_3_1-card.jpg`,
            alt: '',
          },
          modalContent: `
            <div>
              <p>U schrikt er misschien van als het een keer niet lukt om een stijve penis te krijgen. Of om uw penis lang stijf te houden.</p>

              <p>U kunt zich daar onzeker door voelen. U wordt bang dat het de volgende keer weer niet lukt. U maakt zich zorgen dat de seks niet gaat lukken, omdat uw penis niet goed stijf wordt. Dat geeft druk en stress.</p>

              <p>Die gedachten remmen het stijf worden van uw penis. Daardoor kan het de volgende keer moeilijker zijn om een stijve penis te krijgen.</p>
              <img src=${process.env.PUBLIC_URL}/img/ep-stap-2_3_1.jpg alt="" />
            </div>
          `,
        },
        {
          cardTitle: 'Gedachten over seks waardoor u moeilijk een stijve penis krijgt',
          readingTime: '2 minuten leestijd',
          image: {
            src: `${process.env.PUBLIC_URL}/img/ep-stap-2_3_2-card.jpg`,
            alt: '',
          },
          modalContent: `
            <div>
              <p style="margin-bottom: 0;">U kunt gedachten hebben over seks waardoor u moeilijk een stijve penis krijgt.<br/>U denkt bijvoorbeeld dat u een bepaald doel moet halen bij seks. Zoals klaarkomen of lang een stijve penis houden.</p>
              <ul style="margin-top: 0;">
                <li>U heeft ideeën over hoe het 'hoort'. Bijvoorbeeld:
                  <ul><li>seks moet je niet plannen</li>
                  <li>seks zonder dat een penis, dildo of vinger in een vagina of anus gaat is geen echte seks</li>
                  <li>mannen hebben altijd zin</li>
                  <li>vrouwen hebben nooit zin</li>
                  <li>je moet tegelijk klaarkomen</li>
                  <li>seks met jezelf doe je niet als je een vaste relatie hebt</li></ul>
                </li>
                <li>U heeft gedachten waar u zich voor schaamt. Bijvoorbeeld wat u voelt als u zin heeft in seks. Of uw seksuele fantasieën.</li>
                <li>U heeft geleerd dat seks slecht is. U schaamt zich daardoor tijdens seks. Dit kan ervoor zorgen dat u zich niet helemaal kunt ontspannen. Daardoor heeft u liever zo weinig mogelijk seks. Op deze manier beschermt u zichzelf.</li>
              </ul>
              <p>Als u zulke gedachten heeft, kan dat zorgen voor minder zin in seks. Omdat ze niet passen bij wat u eigenlijk wilt of voelt.</p>
              <img src=${process.env.PUBLIC_URL}/img/ep-stap-2_3_2.jpg alt="" />
            </div>
          `,
        },
        {
          cardTitle: 'Stress, angst of vervelende ervaringen',
          readingTime: '2 minuten leestijd',
          image: {
            src: `${process.env.PUBLIC_URL}/img/ep-stap-2_3_3-card.jpg`,
            alt: '',
          },
          modalContent: `
            <div>
              <p style="margin-bottom: 0;">Stress kan ervoor zorgen dat u minder aandacht en energie heeft voor seks. En daardoor minder zin krijgt.</p>
              <ul style="margin-top: 0;">
                <li>U kunt stress hebben als u heel druk bent. Als er vervelende dingen gebeuren, op uw werk, met geld, in uw relatie of problemen met kinderen. Of als er belangrijke dingen gebeuren, zoals een nieuwe baan of een kind krijgen.</li>
                <li>Misschien bent u onzeker of bang bij het vrijen. Dat kan ervoor zorgen dat u probeert om geen seks te hebben. Dat gaat vaak vanzelf, zonder dat u dat beseft. Voorbeelden
                zijn: bang dat het vrijen pijn zal doen, bang dat uw penis niet stijf blijft of bang dat u geen controle meer heeft.</li>
                <li>Misschien heeft u of uw partner een ziekte. Daar kunt u ook onzeker of bang over zijn. U denkt bijvoorbeeld dat seks voor u of uw partner gevaarlijk is door de ziekte. Of dat seks pijn doet door de ziekte.</li>
                <li>Misschien heeft u vervelende ervaringen met seks gehad. Ook dat kan zorgen voor stress en bang zijn.</li>
              </ul>
              <img src=${process.env.PUBLIC_URL}/img/ep-stap-2_3_3.jpg alt="" />
            </div>
          `,
        },
      ],
      button: 'Klaar met lezen, naar de volgende stap',
    },
    {
      path: '/stap-2/de-situatie-of-uw-relatie-als-oorzaak',
      routeId: 'P12-008',
      nextRouteId: 'P12-009',
      type: 'popupCards',
      title: 'De situatie of uw relatie als oorzaak',
      align: 'left',
      description: `
        <div>
          <p>Hieronder staat hoe de situatie en uw relatie kunnen zorgen dat uw penis niet goed stijf wordt. </br> Klik op de onderwerpen waar u meer over wilt weten.</p>
        </div>
      `,
      cards: [
        {
          cardTitle: 'Prikkels die voor u niet goed werken',
          readingTime: '2 minuten leestijd',
          image: {
            src: `${process.env.PUBLIC_URL}/img/ep-stap-2_4_1-card.jpg`,
            alt: '',
          },
          modalContent: `
            <div>
              <p>Om zin in seks te krijgen, zijn prikkels nodig.</p>

              <p style="margin-bottom: 0;">Er kunnen te weinig prikkels zijn. Of voor u niet de goede prikkels. Bijvoorbeeld:</p>
              <ul style="margin-top: 0;">
                <li>U en uw partner raken elkaar weinig aan. Of uw partner raakt uw penis of andere gevoelige plekken van uw lichaam niet aan, terwijl u dat wel graag wilt.</li>
                <li>De seks is altijd hetzelfde. Voor u wordt het saai en is het niet spannend genoeg.</li>
                <li>Misschien heeft u vaak porno gekeken. Door porno heeft u misschien gedachten over hoe seks zou moeten zijn.<br/>
                Als u seks heeft met uw partner gaat het anders dan u heeft gezien. Dan kan het soms zijn dat u moeilijker een
                stijve penis krijgt als u seks met uw partner heeft.</li>
              </ul>

              <p style="margin-bottom: 0;">Soms helpt de situatie niet, bijvoorbeeld:</p>
              <ul style="margin-top: 0;">
                <li>Uw kind slaapt ook in uw slaapkamer.</li>
                <li>Uw kinderen kunnen elk moment uw slaapkamer binnenkomen.</li>
                <li>U en uw partner zijn te druk met andere dingen. U en uw partner doen weinig dingen samen. Of u heeft geen gezellige momenten samen.</li>
              </ul>
              <img src=${process.env.PUBLIC_URL}/img/ep-stap-2_4_1.jpg alt="" />
            </div>
          `,
        },
        {
          cardTitle: 'Verschillen of problemen tussen u en uw partner',
          readingTime: '2 minuten leestijd',
          image: {
            src: `${process.env.PUBLIC_URL}/img/ep-stap-2_4_2-card.jpg`,
            alt: '',
          },
          modalContent: `
            <div>
              <p>Soms zorgen seksuele klachten bij uw partner ook voor klachten bij u. Uw partner krijgt bijvoorbeeld moeilijk een stijve penis. Of uw partner heeft pijn in haar vagina tijdens de seks.
              Bijvoorbeeld omdat tijdens seks de vagina minder snel vochtig wordt door de overgang. Daardoor wordt u onzeker en heeft u minder zin.<br/>
              Misschien is uw partner ziek. Dat kan ervoor zorgen dat u uw partner minder aantrekkelijk vindt.</p>

              <p>Tussen u en uw partner kan er ook een verschil zijn in hoe en hoe vaak u seks wilt. Uw partner heeft bijvoorbeeld meer zin en laat dat vaak aan u weten. Daardoor kunt u steeds minder zin krijgen.</p>

              <p>Het kan ook problemen bij seks geven als u tijdens uw opvoeding andere ideeën over seks heeft geleerd dan uw partner.</p>
              <img src=${process.env.PUBLIC_URL}/img/ep-stap-2_4_2.jpg alt="" />
            </div>
          `,
        },
      ],
      button: 'Klaar met lezen, naar de volgende stap',
    },
    {
      path: '/stap-3',
      routeIndex: '3',
      routeId: 'P12-009',
      nextRouteId: 'P12-010',
      type: 'chapter',
      title: 'Wat kunt u eraan doen?',
      subtitle: 'Stap 3',
      description: `
        <p>U heeft nu misschien een idee waar de problemen bij u door kunnen komen.</p>

        <p>Nu kunt u kijken welke adviezen en behandelingen er voor u zijn.</p>
      `,
      image: {
        src: `${process.env.PUBLIC_URL}/img/ep-stap-3.jpg`,
        alt: '',
      },
      button: 'Ga verder',
    },
    {
      path: '/stap-3/adviezen-bij-alle-oorzaken',
      routeId: 'P12-010',
      nextRouteId: 'P12-011',
      type: 'explanation',
      title: 'Adviezen bij alle oorzaken',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>Op de volgende pagina's vindt u adviezen die iedereen kan proberen. Ze kunnen altijd helpen, wat de oorzaak van uw klachten ook is.</p>

          <p>Na elke pagina krijgt u een vraag. U kunt daarbij opschrijven wat voor u belangrijk is. Aan het eind van de keuzehulp kunt u uw aantekeningen printen.</p>

          <p>U kunt dit ook met uw huisarts bespreken. Misschien vindt u dat lastig. U hoeft zich niet te schamen, voor de huisarts is dit een heel gewoon onderwerp.</p>
        </div>
      `,
      button: 'Ga verder',
    },
    {
      path: '/stap-3/gezonder-leven',
      routeId: 'P12-011',
      nextRouteId: 'P12-012',
      type: 'explanation',
      title: 'Gezonder leven',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>Gezonder gaan leven maakt u fitter: uw bloedvaten, uw zenuwen, uw conditie, uw geest. Alles werkt beter als u gezond leeft. Dat kan ook helpen om een stijvere penis te krijgen en houden.</p>

          <p style="margin-bottom:0;">Adviezen om gezonder te gaan leven:</p>
          <ul style="margin-top:0;">
            <li>Als u te zwaar bent, is het goed om wat af te vallen. Het is vooral belangrijk dat uw buik minder dik wordt. Uw lichaam maakt dan weer meer testosteron.
            Woog u bijvoorbeeld 100 kilo en bent u 10 kilo afgevallen? Dan geeft dat al veel verbetering.</li>
            <li>Stop met roken als u rookt. Vraag hulp bij uw huisarts. Dan is de kans het grootst dat u stopt.</li>
            <li>Geen alcohol drinken is het beste voor uw gezondheid. Vindt u het moeilijk om minder of geen alcohol te drinken? De huisarts of praktijkondersteuner kan u helpen om minder te drinken of te stoppen.</li>
            <li>Bewegen is belangrijk. Beweeg elke dag minstens een half uur actief. Bijvoorbeeld wandelen, fietsen, hardlopen, voetballen, fitness of dansen.</li>
            <li>Zorg voor minder stress.</li>
            <li>Eet gezond.</li>
          </ul>
        </div>
      `,
      button: 'Ga verder',
    },
    {
      path: '/stap-3/bekijk-tips',
      routeId: 'P12-012',
      nextRouteId: 'P12-013',
      type: 'explanation',
      title: 'Bekijk hier tips om gezonder te gaan leven',
      videos: [
        {
          title: 'Gezond afvallen',
          src: 'https://media.thuisarts.nl/gezond-afvallen-doe-je-zo.mp4',
          soundSrc: 'https://media.thuisarts.nl/gezond-afvallen-doe-je-zo.mp3',
          poster: 'https://media.thuisarts.nl/gezond-afvallen-doe-je-zo.jpg',
          videoSize: '107mb',
          subtitles: [
            {
              default: true,
              kind: 'subtitles',
              srclang: 'nl',
              label: 'Dutch',
              src: 'https://media.thuisarts.nl/gezond-afvallen-doe-je-zo.vtt',
              subtitleSize: '6,8kb',
            },
          ],
        },
        {
          title: 'Meer bewegen',
          src: 'https://media.thuisarts.nl/zvm-meer-bewegen.mp4',
          soundSrc: 'https://media.thuisarts.nl/zvm-meer-bewegen.mp3',
          poster: 'https://media.thuisarts.nl/zvm-meer-bewegen.jpg',
          videoSize: '24mb',
          subtitles: [
            {
              default: true,
              kind: 'subtitles',
              srclang: 'nl',
              label: 'Dutch',
              src: 'https://media.thuisarts.nl/zvm-meer-bewegen.vtt',
              subtitleSize: '4kb',
            },
          ],
        },
        {
          title: 'Volhouden',
          src: 'https://media.thuisarts.nl/zvm-volhouden.mp4',
          soundSrc: 'https://media.thuisarts.nl/zvm-volhouden.mp3',
          poster: 'https://media.thuisarts.nl/zvm-volhouden.jpg',
          videoSize: '24mb',
          subtitles: [
            {
              default: true,
              kind: 'subtitles',
              srclang: 'nl',
              label: 'Dutch',
              src: 'https://media.thuisarts.nl/zvm-volhouden.vtt',
              subtitleSize: '3kb',
            },
          ],
        },
      ],
      button: 'Ga verder',
    },
    {
      path: '/stap-3/vraag-1',
      routeId: 'P12-013',
      nextRouteId: 'P12-014',
      type: 'question',
      title: 'Hoe wilt u gezonder gaan leven?',
      subtitle: 'Vraag',
      description:
        '<p>Vertel wat u wilt veranderen. Of welke hulp u daarbij nodig heeft. Bijvoorbeeld dat u wilt afvallen. Of dat u wilt stoppen met roken, alcohol of drugs.</p>',
      descriptionAlign: 'left',
      button: 'Ga verder',
      questions: [
        {
          placeholder: ' Typ hier uw antwoord.',
          type: 'textarea',
        },
      ],
    },
    {
      path: '/stap-3/erover-praten-met-uw-partner',
      routeId: 'P12-014',
      nextRouteId: 'P12-015',
      type: 'explanation',
      title: 'Erover praten met uw partner',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>Praat met uw partner over seks. U weet dan of het een probleem is voor uw partner dat uw penis soms niet goed stijf wordt. En u kunt vertellen of het een probleem is voor u.</p>

          <p style="margin-bottom:0;">Misschien vindt u het niet makkelijk om over uw relatie en seks te praten. Probeer het toch eens. We weten dat het vaak goed helpt. </br> Tips hoe u er het beste over kunt praten:</p>
          <ul style="margin-top:0;">
            <li>Praat er bijvoorbeeld tijdens een wandeling over, of aan tafel. Liever niet in bed of als de seks niet gaat zoals u wilt.</li>
            <li>Praat er ook niet te lang achter elkaar over. Praat bijvoorbeeld de komende weken een half uur per keer.</li>
            <li>Spreek samen uw doel af: samen kijken hoe het met de seks gaat en wat u zou kunnen en willen veranderen.</li>
            <li>Geef de ander niet de schuld van de problemen. Luister naar elkaar. Zoek samen naar oplossingen.</li>
            <li>Vertel ook wat u zelf kunt veranderen en hoe uw partner daarbij kan helpen.</li>
          </ul>
          %MODALLINK%
        </div>
      `,
      modalLink: 'Voorbeelden om erover te praten',
      modalHeader: 'Voorbeelden om over te praten met uw partner',
      modalText: `
        <p style="margin-bottom:0;">U kunt bijvoorbeeld samen praten over deze dingen:</p>
        <ul style="margin-top:0;">
          <li>Voelt u zich minder aantrekkelijk? Schaamt u zich voor iets?</li>
          <li>Bent u bang dat u geen stijve penis krijgt?</li>
          <li>Zijn er problemen met uw lichaam? Bijvoorbeeld pijn in uw gewrichten, plas niet goed kunnen ophouden of een slechte adem?</li>
          <li>Bent u nog blij met elkaar? Vindt u elkaar nog leuk? Vindt u de seks met elkaar nog leuk?</li>
          <li>Mist u iets tijdens de seks? Is de seks saai of voorspelbaar geworden?</li>
          <li>Wordt u nog seksueel opgewonden van elkaar?</li>
          <li>Hoe voelt u zich? Bent u misschien somber? Heeft u veel stress?</li>
          <li>Wat zijn de wensen op seksueel gebied? Hebben jullie dezelfde wensen? Bijvoorbeeld:
            <ul><li>Wilt u vaker knuffelen in plaats van seks waarbij de penis in de vagina of anus gaat?</li>
            <li>Vindt u klaarkomen wel of niet belangrijk?</li>
            <li>Welke houding is voor u prettig, of welke houding doet juist pijn?</li></ul>
          </li>
        </ul>
      `,
      button: 'Ga verder',
    },
    {
      path: '/stap-3/vraag-2',
      routeId: 'P12-015',
      nextRouteId: 'P12-016',
      type: 'question',
      title: 'Hoe denkt u over praten met uw partner over seks?',
      subtitle: 'Vraag',
      description: '<p>Vertel waarom u wilt praten met uw partner. Of wat u wilt zeggen.</p>',
      descriptionAlign: 'left',
      button: 'Ga verder',
      questions: [
        {
          placeholder: 'Typ hier uw antwoord.',
          type: 'textarea',
        },
      ],
    },
    {
      path: '/stap-3/andere-manieren-van-seks',
      routeId: 'P12-016',
      nextRouteId: 'P12-017',
      type: 'explanation',
      title: 'Andere manieren van seks: meer plezier en ontspanning',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>Seks is geen prestatie. U hoeft niet van alles te presteren of te bereiken. Een stijve penis, klaarkomen of de penis in de vagina is geen doel van seks. Plezier en ontspanning zijn het belangrijkst.</p>

          <p>Fijne seks hoeft niet seks te zijn waarbij een penis, dildo of vinger in de vagina of anus gaat. Als u het idee heeft dat dat zo 'hoort', kan dat ervoor zorgen dat u geen fijne seks heeft.</p>

          <p>Praat hierover en probeer andere manieren van vrijen. </br> Seks kan ook fijn zijn door te zoenen of elkaar te strelen of masseren. Dat kan helpen om samen weer meer zin en plezier in seks te krijgen.</br>
          Bent u bang om geen stijve penis te krijgen? Dan kan het ook helpen om seks te hebben zonder dat de penis in de vagina of anus moet. Dit is vaak een van de eerste adviezen als u naar een arts gaat.</p>

          %MODALLINK%
        </div>
      `,
      modalLink: 'Bekijk tips over strelen en masseren',
      modalHeader: 'Tips over strelen en masseren',
      modalText: `
        <p>Streel uw partner 5 minuten overal op het lichaam, behalve de gevoelige delen, zoals de penis, vagina, anus en borsten.</br>
        Wissel dan om: uw partner streelt u 5 minuten.</br>
        Probeer te ontspannen.</br>
        Zeg het als u iets niet fijn vindt.</br>
        Vertel daarna aan elkaar hoe u de oefening vond.</br>
        Meer tips voor deze oefening vindt u op <a href="https://www.thuisarts.nl/seks/elkaar-strelen-of-masseren-ook-penis-vagina-anus-en-borsten#oefening-elkaar-strelen-en-masseren-ook-de-penis-vagina-anus-en-borsten" target="_blank">Thuisarts.nl</a>.</p>
      `,
      button: 'Ga verder',
    },
    {
      path: '/stap-3/vraag-3',
      routeId: 'P12-017',
      nextRouteId: 'P12-018',
      type: 'question',
      title: 'Hoe denkt u over strelen en masseren?',
      subtitle: 'Vraag',
      description: '<p>Vertel waarom u denkt dat strelen en masseren u wel of niet kan helpen.</p>',
      descriptionAlign: 'left',
      button: 'Ga verder',
      questions: [
        {
          placeholder: ' Typ hier uw antwoord.',
          type: 'textarea',
        },
      ],
    },
    {
      path: '/stap-3/extra-seksuele-prikkels',
      routeId: 'P12-018',
      nextRouteId: 'P12-019',
      type: 'explanation',
      title: 'Extra seksuele prikkels',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>Zin in seks komt niet vanzelf. Ga dus op zoek naar seksuele prikkels.</br>
          Doe wat u en uw partner prettig en opwindend vinden. Voor veel mensen is het belangrijk niet steeds hetzelfde te doen om zin te krijgen in seks.</p>

          <p style="margin-bottom:0;">Extra seksuele prikkels kunnen helpen:</p>
          <ul style="margin-top:0;">
            <li>andere standjes proberen</li>
            <li>een glijmiddel gebruiken</li>
            <li>een vibrator gebruiken</li>
            <li>op een andere plaats dan in de slaapkamer</li>
            <li>seksfilms, seksverhalen of foto’s</li>
            <li>andere manieren van strelen en masseren</li>
            <li>seks met jezelf</li>
          </ul>
        </div>
      `,
      button: 'Ga verder',
    },
    {
      path: '/stap-3/vraag-4',
      routeId: 'P12-019',
      nextRouteId: 'P12-020',
      type: 'question',
      hideFromOverview: false,
      title: 'Wilt u extra seksuele prikkels gaan proberen?',
      subtitle: 'Vraag',
      descriptionAlign: 'left',
      questions: [
        {
          type: 'single',
          answers: [
            {
              title: 'Ja',
            },
            {
              title: 'Nee',
            },
          ],
        },
      ],
      showTextArea: true,
      button: 'Ga verder',
    },
    {
      path: '/stap-3/minder-stress',
      routeId: 'P12-020',
      nextRouteId: 'P12-021',
      type: 'explanation',
      title: 'Minder stress',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>Als u zich ontspannen voelt, heeft u meer aandacht voor seksuele prikkels. Om te ontspannen kan het helpen om seks te hebben zonder stijve penis. Of zonder dat de penis in de vagina of anus moet.</p>

          <p style="margin-bottom:0;">Uw penis kan daardoor makkelijker stijf worden. </br> Deze adviezen kunnen helpen om beter met stress om te gaan:</p>
          <ul style="margin-top: 0;">
            <li>Zorg goed voor uzelf: beweeg veel, eet gezond en slaap genoeg.</li>
            <li>Denk na over wat bij u spanning geeft. En wat u energie geeft.</li>
            <li>Praat er met iemand over die u vertrouwt.</li>
          </ul>
          <p>U kunt het ook opschrijven.</p>
        </div>
      `,
      videos: [
        {
          title: 'Minder stress',
          src: 'https://media.thuisarts.nl/zvm-minder-stress.mp4',
          soundSrc: 'https://media.thuisarts.nl/zvm-minder-stress.mp3',
          poster: 'https://media.thuisarts.nl/zvm-minder-stress.jpg',
          videoSize: '25mb',
          subtitles: [
            {
              default: true,
              kind: 'subtitles',
              srclang: 'nl',
              label: 'Dutch',
              src: 'https://media.thuisarts.nl/zvm-minder-stress.vtt',
              subtitleSize: '3kb',
            },
          ],
        },
        {
          title: 'Wat kun je doen om je goed te voelen?',
          src: 'https://media.thuisarts.nl/wat-kun-je-doen-om-je-goed-te-voelen-thuisarts.mp4',
          soundSrc: 'https://media.thuisarts.nl/wat-kun-je-doen-om-je-goed-te-voelen-thuisarts.mp3',
          poster: 'https://media.thuisarts.nl/wat-kun-je-doen-om-je-goed-te-voelen-thuisarts.jpg',
          videoSize: '143mb',
          subtitles: [
            {
              default: true,
              kind: 'subtitles',
              srclang: 'nl',
              label: 'Dutch',
              src: 'https://media.thuisarts.nl/wat-kun-je-doen-om-je-goed-te-voelen-thuisarts.vtt',
              subtitleSize: '3kb',
            },
          ],
        },
      ],
      button: 'Ga verder',
    },
    {
      path: '/stap-3/vraag-5',
      routeId: 'P12-021',
      nextRouteId: 'P12-022',
      type: 'question',
      hideFromOverview: false,
      title: 'Heeft u veel stress?',
      subtitle: 'Vraag',
      description: 'Vertel wat u wilt gaan doen om minder stress te hebben.',
      descriptionAlign: 'left',
      questions: [
        {
          type: 'single',
          answers: [
            {
              title: 'Ja',
            },
            {
              title: 'Nee',
            },
          ],
        },
      ],
      showTextArea: true,
      button: 'Ga verder',
    },
    {
      path: '/stap-3/niets-doen',
      routeId: 'P12-022',
      nextRouteId: 'P12-023',
      type: 'explanation',
      title: 'Niets doen',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>Misschien vinden u en uw partner het niet meer zo belangrijk om seks te hebben waarbij de penis in de vagina of anus gaat. Of misschien vinden u en uw partner het niet nodig om er iets aan te doen. Bijvoorbeeld als u al wat ouder bent.</p>

          <p>U weet nu dat het normaal is dat de penis minder makkelijk stijf wordt op oudere leeftijd. Misschien bent u daardoor al gerustgesteld.</p>

          <p>Misschien beseft u nu dat u tijdelijk minder energie heeft voor seks. Bijvoorbeeld omdat u iets ergs heeft meegemaakt.</p>

          <ul>
            <li>Praat hier samen over.</li>
            <li>En blijf elkaar veel aanraken en knuffelen.</li>
            <li>Blijf ook genoeg andere dingen samendoen en samen een gezellige tijd hebben.</li>
          </ul>
        </div>
      `,
      button: 'Ga verder',
    },
    {
      path: '/stap-3/vraag-6',
      routeId: 'P12-023',
      nextRouteId: 'P12-024',
      type: 'question',
      title: 'Hoe belangrijk is het voor u dat u een stijve penis kunt krijgen?',
      subtitle: 'Vraag',
      button: 'Ga verder',
      questions: [
        {
          placeholder: ' Typ hier uw antwoord.',
          type: 'textarea',
        },
      ],
    },
    {
      path: '/stap-3/seksualoog',
      routeId: 'P12-024',
      nextRouteId: 'P12-025',
      type: 'explanation',
      title: 'Gesprekken met iemand die veel weet over problemen bij seks (seksuoloog)',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>Met de seksuoloog bespreekt u waar de problemen bij u door kunnen komen. Als dat duidelijk is, kijkt u samen wat u eraan kunt doen.</p>

          <p>U kunt bijvoorbeeld oefeningen krijgen voor strelen en masseren.</p>

          <p>Meestal zijn 4, 5 of 6 gesprekken genoeg.</p>

          <a href="https://seksualiteit.nl/tips-tools/naar-de-seksuoloog/" target="_blank">Bekijk meer informatie over de seksuoloog.</a>
        </div>
      `,
      button: 'Ga verder',
    },
    {
      path: '/stap-3/vraag-7',
      routeId: 'P12-025',
      nextRouteId: 'P12-026',
      type: 'question',
      title: 'Hoe denkt u over gesprekken met iemand die veel weet van problemen bij seks?',
      description:
        'Vertel hoe u denkt over gesprekken met iemand die veel weet van problemen bij seks. Of vertel wat u wilt bespreken met zo iemand.',
      descriptionAlign: 'left',
      subtitle: 'Vraag',
      button: 'Ga verder',
      questions: [
        {
          placeholder: ' Typ hier uw antwoord.',
          type: 'textarea',
        },
      ],
    },
    {
      path: '/stap-3/meer-adviezen',
      routeId: 'P12-026',
      nextRouteId: 'P12-027',
      type: 'explanation',
      title: 'Meer adviezen',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>U heeft nu de adviezen gelezen die iedereen kan proberen.</p>

          <p>Op de volgende pagina vindt u nog meer adviezen. Dit zijn adviezen die kunnen helpen als uw klachten vooral een lichamelijke oorzaak hebben.</p>
        </div>
      `,
      button: 'Ga verder',
    },

    {
      path: '/stap-3/extra-adviezen-bij-lichamelijke-oorzaken',
      routeId: 'P12-027',
      nextRouteId: 'P12-028',
      type: 'popupCards',
      title: 'Extra adviezen bij lichamelijke oorzaken',
      align: 'left',
      description: `
        <div>
          <p>Hieronder staan adviezen die kunnen helpen als uw klachten een lichamelijke oorzaak hebben. Klik op de adviezen waar u meer over wilt weten.</p>
        </div>
      `,
      cards: [
        {
          cardTitle: 'Uw medicijnen bespreken met uw arts',
          readingTime: '1 minuut leestijd',
          image: {
            src: `${process.env.PUBLIC_URL}/img/ep-stap-3_17_1-card.jpg`,
            alt: '',
          },
          modalContent: `
            <div>
              <p>Door sommige medicijnen wordt de penis niet goed stijf. Bijvoorbeeld door medicijnen tegen plasklachten, medicijnen bij hoge bloeddruk, slaappillen, kalmerings-pillen en medicijnen tegen angst en depressie.</p>

              <p>Misschien kunt u stoppen met het medicijn of een ander medicijn krijgen. Bespreek dit met uw arts. Stop niet zelf opeens met uw medicijn.</p>
            </div>
          `,
        },
        {
          cardTitle: 'Erectie-pil',
          readingTime: '2 minuten leestijd',
          image: {
            src: `${process.env.PUBLIC_URL}/img/ep-stap-3_17_2-card.jpg`,
            alt: '',
          },
          modalContent: `
            <div>
              <p>Erectie-pillen kunnen helpen als u een probleem heeft waardoor uw penis niet goed stijf wordt. Bijvoorbeeld ouder worden, diabetes of een ziekte van hart of bloedvaten.</p>

              <p>De erectie-pil werkt als u ontspannen bent en zin heeft in seks. Een erectie-pil werkt ongeveer 30 minuten na het slikken. Uw penis is steviger en blijft langer stijf.
              De eerste paar keer dat u een erectie-pil slikt, kan het gebeuren dat die nog niet zo goed werkt. U kunt het daarom het beste een paar keer proberen. Meestal weet u na 6 keer of de pil goed bij u werkt.</p>

              <p style="margin-bottom:0;">Erectie-pillen kunnen bijwerkingen hebben, zoals:</p>
              <ul style="margin-top:0;">
                <li>hoofdpijn</li>
                <li>een rood gezicht</li>
                <li>een warm gevoel</li>
              </ul>

              <p>Heeft u de pillen een paar keer gebruikt? Dan zijn de bijwerkingen meestal weg of minder.</p>

              <p>Uw huisarts of arts in het ziekenhuis kan u een recept geven voor erectie-pillen.</p>

              <p>Gebruikt u al medicijnen? Of heeft u hartklachten of een hele lage bloeddruk? Vraag eerst aan uw arts of u erectie-pillen mag gebruiken.</p>

              <p>De pillen worden bijna nooit vergoed door uw zorgverzekeraar. U kunt dit navragen bij uw zorgverzekeraar. Koop de pillen altijd bij de apotheek. Dan weet u zeker dat het goede medicijn in de pillen zit.
              En dat er niet te veel of te weinig medicijn in de pillen zit. Tien erectie-pillen kosten ongeveer 30 tot 60 euro.</p>
            </div>
          `,
          videos: [
            {
              title: 'Erectiepillen',
              src: 'https://media.thuisarts.nl/erectiepillen.mp4',
              soundSrc: 'https://media.thuisarts.nl/erectiepillen.mp3',
              poster: 'https://media.thuisarts.nl/erectiepillen.jpg',
              videoSize: '24mb',
              subtitles: [
                {
                  default: true,
                  kind: 'subtitles',
                  srclang: 'nl',
                  label: 'Dutch',
                  src: 'https://media.thuisarts.nl/erectiepillen.vtt',
                  subtitleSize: '3kb',
                },
              ],
            },
          ],
        },
        {
          cardTitle: 'Penis-ring',
          readingTime: '2 minuten leestijd',
          image: {
            src: `${process.env.PUBLIC_URL}/img/ep-stap-3_17_3-card.jpg`,
            alt: '',
          },
          modalContent: `
            <div>
              <p style="margin-bottom:0;">Een penis-ring helpt om een stijve penis te houden:</p>
              <ul style="margin-top:0;">
                <li>U schuift de ring over uw penis.</li>
                <li>Schuif de ring zo ver mogelijk naar uw buik.</li>
                <li>Als uw penis stijf wordt, zit de ring strakker. Het bloed kan daardoor moeilijker weg uit de penis. Hierdoor blijft uw penis stijf.</li>
                <li>Laat de penis-ring de eerste keer 10 minuten zitten. Zo kunt u wennen aan het gevoel.</li>
                <li>De ring mag ongeveer 25 minuten blijven zitten.</li>
                <li>Pas op dat u niet met de ring om uw penis in slaap valt. </br> De penis blijft dan veel te lang stijf. Dat kan de bloedvaten in de penis kapot maken.</li>
              </ul>

              <p>U kunt door de penis-ring blauwe plekken op de penis krijgen. Dit gebeurt vooral als u bloedverdunners gebruikt (medicijnen waardoor uw bloed minder snel stolt).</br>
              Een penis-ring kunt u kopen bij seks-winkels en internet-winkels. Een penis-ring kost ongeveer 20 euro.</p>
            </div>
          `,
        },
        {
          cardTitle: 'Penis-pomp',
          readingTime: '2 minuten leestijd',
          image: {
            src: `${process.env.PUBLIC_URL}/img/ep-stap-3_17_4-card.jpg`,
            alt: '',
          },
          modalContent: `
            <div>
              <p style="margin-bottom:0;">Een penis-pomp helpt om een stijve penis te krijgen.</p>
              <ul style="margin-top:0;">
                <li>Lees eerst de gebruiksaanwijzing. Dan weet u hoe u de pomp gebruikt.</li>
                <li>De penis-pomp is een koker die u over uw penis doet.</li>
                <li>Door de penis-pomp te pompen, komt er meer bloed in de penis.</li>
                <li>Hierdoor wordt de penis stijf.</li>
                <li>Pomp niet te snel.</li>
                <li>Daarna houdt u uw penis stijf met een penis-ring.</li>
                <li>Stop met de penis-pomp als het pijn doet.</li>
              </ul>

              <p>U kunt door de penis-pomp blauwe plekken op de penis krijgen. Dit gebeurt vooral als u bloedverdunners gebruikt (medicijnen waardoor uw bloed minder snel stolt).</p>

              <p>Deze hulpmiddelen kunt u kopen bij seks-winkels en internet-winkels. Een penis-pomp kost ongeveer 30 tot 300 euro.</p>
            </div>
          `,
        },
        {
          cardTitle: 'Zelf prikken in uw penis geven',
          readingTime: '2 minuten leestijd',
          image: {
            src: `${process.env.PUBLIC_URL}/img/ep-stap-3_17_5-card.jpg`,
            alt: '',
          },
          modalContent: `
            <div>
              <p>Deze behandeling kan de arts in het ziekenhuis met u bespreken.</p>

              <p>De behandeling gaat zo:</br>
              Voor de seks spuit u een medicijn in de zwel-lichamen van uw penis. Daardoor gaat er meer bloed naar de penis. Na de prik kan het 5 tot 20 minuten duren tot uw penis stijf wordt.</p>

              <p>U kunt leren hoe u moet prikken in het ziekenhuis. Daar vertelt de arts ook welke risico’s deze behandeling heeft. U mag het medicijn 1 keer per week gebruiken.
              Soms kunt u de prik vaker gebruiken als u dat met uw arts heeft besproken.</p>

              <p>Vaak moet u de prik een paar keer proberen voordat u weet of het werkt en hoeveel van het medicijn u nodig heeft.</p>

              <p>De prikken kosten ongeveer 12 euro per keer.</p>
            </div>
          `,
        },
        {
          cardTitle: 'Een kunst zwel-lichaam (penis-prothese)',
          readingTime: '1 minuut leestijd',
          image: {
            src: `${process.env.PUBLIC_URL}/img/ep-stap-3_17_6-card.jpg`,
            alt: '',
          },
          modalContent: `
            <div>
              <p>Deze behandeling kan de arts in het ziekenhuis met u bespreken. Artsen raden deze behandeling alleen aan als andere behandelingen niet helpen.</p>

              <p>Een kunst zwel-lichaam wordt tijdens een operatie in uw penis gezet.</br>
              Uw eigen zwel-lichamen gaan hierdoor kapot. Als de kunst zwel-lichamen eruit moeten, kunt u daardoor na de operatie nooit meer zelf een stijve penis krijgen.</p>

              <p>Er bestaan verschillende soorten. De arts in het ziekenhuis kan u uitleggen wat de verschillen zijn. En wat de voordelen en andere nadelen zijn.</p>
            </div>
          `,
        },
      ],
      button: 'Klaar met lezen, naar de volgende stap',
    },
    {
      path: '/stap-3/vraag-8',
      routeId: 'P12-028',
      nextRouteId: 'P12-029',
      type: 'question',
      hideFromOverview: false,
      title: 'Wat zou u misschien willen proberen?',
      subtitle: 'Vraag',
      description: `
        U kunt meerdere antwoorden kiezen.
        `,
      descriptionAlign: 'left',
      questions: [
        {
          type: 'multiple',
          answers: [
            {
              title: 'Uw medicijnen bespreken met uw arts',
            },
            {
              title: 'Erectie-pil',
            },
            {
              title: 'Penisring',
            },
            {
              title: 'Penis-pomp',
            },
            {
              title: 'Zelf prikken in uw penis geven',
            },
            {
              title: 'Een kunst zwel-lichaam',
            },
            {
              title: 'Geen',
              deselectOthers: true,
            },
          ],
        },
      ],
      showTextArea: true,
      button: 'Ga verder',
    },
    {
      path: '/print-overview',
      routeIndex: '4',
      routeId: 'P12-029',
      nextRouteId: 'end',
      type: 'end',
      header: {
        title: 'U bent klaar',
        description: `
          <div>
            <p style="margin-bottom: 0;">U heeft nu:</p>
            <ul style="margin-top: 0;">
              <li>gelezen waardoor uw klachten kunnen komen</li>
              <li>gelezen welke adviezen en behandelingen er zijn</li>
              <li>nagedacht over welke adviezen of behandelingen u misschien wilt proberen</li>
            </ul>

            <p>We hebben uw antwoorden op een rij gezet. Die kunt u gebruiken in een gesprek met uw arts. Samen beslist u wat u gaat proberen.</p>
          </div>
        `,
      },
    },
  ],
}

export default erectieproblemen
